/*
 * filename: assets/sr-calc-core.js
 */
(function () {
  function clampNumber(n, fallback) {
    const x = Number(n);
    return Number.isFinite(x) ? x : fallback;
  }

  function roundTo(n, decimals) {
    const p = Math.pow(10, decimals);
    return Math.round(n * p) / p;
  }

  function ceilToMultiple(value, multiple) {
    if (!multiple || multiple <= 0) return value;
    return Math.ceil(value / multiple) * multiple;
  }

  function uuid() {
    return "w_" + Math.random().toString(16).slice(2) + "_" + Date.now().toString(16);
  }

  function downloadJson(filename, obj) {
    const blob = new Blob([JSON.stringify(obj, null, 2)], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  }

  function parseDefaults(el) {
    const raw = el.getAttribute("data-defaults") || "{}";
    try { return JSON.parse(raw); } catch (e) { return {}; }
  }

  function trackingSessionId() {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return window.crypto.randomUUID();
    }
    return "calc_" + Math.random().toString(16).slice(2) + "_" + Date.now().toString(16);
  }

  function createTrackingContext(el, calcType) {
    return {
      calcType: String(calcType || el.dataset.srCalc || "unknown"),
      source: String(el.dataset.srSource || "direct"),
      sessionId: trackingSessionId()
    };
  }

  function buildCartTracking(context, product) {
    const variantId = Number(product.variantId);
    const quantity = Math.max(0, Number(product.quantity) || 0);
    const priceCents = Math.max(0, Number(product.priceCents) || 0);
    const unitPrice = roundTo(priceCents / 100, 2);
    const value = roundTo(unitPrice * quantity, 2);
    const handle = String(product.productHandle || "");

    return {
      event: {
        variant_id: variantId,
        product_handle: handle,
        qty: quantity,
        price_cents: priceCents,
        value: value,
        currency: String(product.currency || ""),
        calc_source: context.source,
        calc_type: context.calcType,
        calc_session_id: context.sessionId,
        items: [{
          item_id: String(variantId),
          item_name: handle,
          item_category: "yardage_calculator",
          item_variant: String(variantId),
          price: unitPrice,
          quantity: quantity
        }]
      },
      lineProperties: {
        _sr_calculator: context.calcType,
        _sr_calc_source: context.source,
        _sr_calc_session: context.sessionId,
        _sr_calc_version: "1"
      }
    };
  }

  // Expose a tiny shared namespace
  window.SRCalc = {
    utils: { clampNumber, roundTo, ceilToMultiple, uuid, downloadJson },
    parseDefaults,
    createTrackingContext,
    buildCartTracking
  };
})();
